module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/target01-0baf666e15b4a951d58dff8fddc221bc.png";